import React from 'react';

import SpinnerWrapper from 'components/App/PartnerProvider/SpinnerWrapper';
import Spinner from 'components/Spinner';
import InquiryDetailsHeader from 'modules/InquiryDetails/InquiryDetailsHeader';
import FileRequestsFromBank from 'pages/customerPortal/InquiryDetails/DocumentExchange/FileRequestsFromBank/FileRequestsFromBank';
import FilesFromBank from 'pages/customerPortal/InquiryDetails/DocumentExchange/FilesFromBank/FilesFromBank';
import FilesToBank from 'pages/customerPortal/InquiryDetails/DocumentExchange/FilesToBank/FilesToBank';

import {
  useCustomerDocumentExchange,
  useCustomerDocumentExchangeUpdatedInquiryDetailsWebsocket,
} from './useCustomerDocumentExchange';
import InquiryTypeSpecificHeader from '../InquiryDetailsHeaderButton';
import { DzbContractFiles } from '../ProcessSpecificFiles/DzbContractFiles';

export const DZBCustomerDocumentExchange = () => {
  const { isLoading } = useCustomerDocumentExchange();
  useCustomerDocumentExchangeUpdatedInquiryDetailsWebsocket();

  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  return (
    <article>
      <InquiryDetailsHeader>
        <InquiryTypeSpecificHeader />
      </InquiryDetailsHeader>
      <DzbContractFiles />
      <FilesFromBank />
      <FileRequestsFromBank />
      <FilesToBank />
    </article>
  );
};
